import { createContext } from 'react'
import { LanguageState } from './Language.types'

export const defaultState: LanguageState = {
  language: null,
  updateLanguage: () => null,
}

export const LanguageContext = createContext<LanguageState>(defaultState)
